// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2O_gO","log":"ModalInventoryLogs_log__2XpBG","date":"ModalInventoryLogs_date__3-QgD","userName":"ModalInventoryLogs_userName__34z4b"};